import aura1 from "../assets/apps/aura-1.jpg";
import aura2 from "../assets/apps/aura-2.jpg";
import aura3 from "../assets/apps/aura-3.jpg";
import aura4 from "../assets/apps/aura-4.jpg";

import nudge1 from "../assets/apps/nudge-1.jpg";
import nudge2 from "../assets/apps/nudge-2.jpg";
import nudge3 from "../assets/apps/nudge-3.jpg";
import nudge4 from "../assets/apps/nudge-4.jpg";

import falorai1 from "../assets/apps/falorai-1.jpg";
import falorai2 from "../assets/apps/falorai-2.jpg";
import falorai3 from "../assets/apps/falorai-3.jpg";
import falorai4 from "../assets/apps/falorai-4.jpg";

import hepbme1 from "../assets/apps/hepbme-1.jpg";
import hepbme2 from "../assets/apps/hepbme-2.jpg";
import hepbme3 from "../assets/apps/hepbme-3.jpg";
import hepbme4 from "../assets/apps/hepbme-4.jpg";

import mahbub1 from "../assets/apps/mahbub-1.jpg";
import mahbub2 from "../assets/apps/mahbub-2.jpg";
import mahbub3 from "../assets/apps/mahbub-3.jpg";

import refleks1 from "../assets/apps/refleks-1.jpg";
import refleks2 from "../assets/apps/refleks-2.jpg";
import refleks3 from "../assets/apps/refleks-3.jpg";

import morphosonic1 from "../assets/apps/morphosonic-1.jpg";
import morphosonic2 from "../assets/apps/morphosonic-2.jpg";

import designRefleks from "../assets/design/design-refleks.jpg";
import designHepbme from "../assets/design/design-hepbme.jpg";
import designFalorai from "../assets/design/design-falorai.jpg";

import ptp1 from "../assets/apps/ptp-1.jpg";
import ptp2 from "../assets/apps/ptp-2.jpg";
import ptp3 from "../assets/apps/ptp-3.jpg";
import ptp4 from "../assets/apps/ptp-4.jpg";

// Copy is taken from each app's own live store listing, and every store link
// has been checked to return 200. FalorAI and Morphosonic are Play-only:
// FalorAI's old App Store id (6743785211) now 404s, so it is deliberately absent.
//
// `gallery` walks a visitor through the product one screen at a time — each
// entry captions the screenshot it sits with, so the flow reads on its own.
export const projects = [
  {
    id: "aura",
    stack: ["Claude", "RevenueCat"],
    services: ["Product design", "iOS & Android app", "Backend", "AI"],
    name: "Aura — AI Vibe Check",
    tagline:
      "AI reads your aura from a selfie, outfit, room or feed. Scored in seconds.",
    platforms: ["iOS", "Android"],
    category: "AI",
    img: aura4,
    gallery: [
      {
        img: aura1,
        title: "Four ways to get read",
        caption:
          "Point it at a selfie, your outfit, your room, or a screenshot of your feed.",
      },
      {
        img: aura4,
        title: "Scored in seconds",
        caption:
          "An aura score out of 100, a named aesthetic identity, and the headline observation behind it.",
      },
      {
        img: aura2,
        title: "Built to be shared",
        caption:
          "Every read ends in a story-ready card — one tap from result to post.",
      },
      {
        img: aura3,
        title: "The full picture",
        caption:
          "Pro unlocks growth edge, dating compatibility and personalised glow-up plans.",
      },
    ],
    description:
      "Aura reads your energy from a single photo.\n\nTake a selfie, snap your outfit, show it your room, or drop in a screenshot of your feed — and get an instant read on the version of you the world actually sees. No quizzes. No forms. No sign-up. Just a photo and about five seconds.\n\nWHAT AURA READS\n• Selfie — the face read. Your presence, your energy, the first impression you make.\n• Outfit — your fit decoded. Style archetype and the story your clothes are telling.\n• Your Room — spaces say more than people do. What yours reveals about you.\n• Digital You — Instagram grid, TikTok profile, playlist, chat thread. Your online signature, read back to you.\n\nWHAT YOU GET\nEvery read gives you an aura score, an aura type, your aesthetic identity, and a headline observation sharp enough to screenshot — plus a celebrity energy match. One tap turns it into a story-ready card built to be shared.",
    links: {
      appStore: "https://apps.apple.com/us/app/aura-ai-vibe-check/id6772190779",
      googlePlay:
        "https://play.google.com/store/apps/details?id=com.deepcvision.aura",
      website: "https://aura.deepcvision.co.uk",
    },
  },
  {
    id: "nudge",
    stack: ["Claude", "RevenueCat"],
    services: ["Product design", "iOS & Android app", "Backend", "AI"],
    name: "Nudge — Never Drop the Ball",
    tagline:
      "Speak a thought. AI turns it into a follow-up. Never drop the ball again.",
    platforms: ["iOS", "Android"],
    category: "AI",
    img: nudge1,
    gallery: [
      {
        img: nudge3,
        title: "Speak it, however messy",
        caption:
          "Say the thought out loud. No structure, no forms — Nudge takes it from there.",
      },
      {
        img: nudge2,
        title: "AI cleans it up",
        caption:
          "Your rough voice note becomes a clear commitment you can check before saving.",
      },
      {
        img: nudge1,
        title: "One thing at a time",
        caption:
          "Nudge surfaces the single commitment that matters right now, with time and priority.",
      },
      {
        img: nudge4,
        title: "The message is already written",
        caption:
          "Every action arrives with a follow-up drafted in context. Copy it, send it, done.",
      },
    ],
    description:
      "Nudge is the AI-powered commitment tracker that turns messy thoughts into actions — and actions into sent messages.\n\nForget structured to-do lists. Just speak or type whatever's on your mind, and Nudge handles the rest. It cleans up your thought, figures out the priority, and when you're ready to act, the follow-up message is already written for you.\n\nSPEAK IT. NUDGE SORTS IT.\nSay \"email Sarah about the proposal, actually maybe call her\" — Nudge turns that into a clean, prioritised task with a ready-to-send message.\n\nONE THING AT A TIME.\nNudge surfaces your most important commitment right now. Do it, and the next one appears. No overwhelm. Just momentum.\n\nBUILT FOR PEOPLE WHO FOLLOW THROUGH.\nSalespeople. Managers. Freelancers. Founders. Anyone who makes commitments and wants to keep them.",
    links: {
      appStore:
        "https://apps.apple.com/us/app/nudge-never-drop-the-ball/id6763634549",
      googlePlay:
        "https://play.google.com/store/apps/details?id=com.deepcvision.nudgeApp",
      website: "https://nudge.deepcvision.co.uk",
    },
  },
  {
    id: "falorai",
    stack: ["Flutter", "AWS", "RevenueCat"],
    services: ["Branding", "Android app", "Backend", "Computer vision"],
    designCredit: "Brand design with Understated",
    designImage: designFalorai,
    name: "FalorAI",
    tagline:
      "Discover the art of coffee cup reading! Snap your cup and enjoy fun.",
    platforms: ["Android"],
    category: "AI",
    img: falorai4,
    gallery: [
      {
        img: falorai1,
        title: "Start a reading",
        caption:
          "Finish your coffee, flip the cup, and tap once to begin the analysis.",
      },
      {
        img: falorai2,
        title: "Choose what you're curious about",
        caption:
          "Love, career or personal growth — plus the mood you're bringing to it.",
      },
      {
        img: falorai3,
        title: "Four guided angles",
        caption:
          "Front, back, left and right, so the model sees the whole pattern in your cup.",
      },
      {
        img: falorai4,
        title: "Your own personal reading",
        caption:
          "Computer vision reads the grounds in your actual cup — never a generic profile.",
      },
    ],
    description:
      "FalorAI uses AI image recognition to analyze the physical patterns in your coffee cup.\n\nUnlike horoscope or zodiac apps that generate generic content from your birth date, FalorAI requires a real coffee cup and real photos. Our computer vision model examines the actual formations left by your grounds — every reading is unique because every cup is unique.\n\nHOW IT WORKS\n① Finish your coffee and flip the cup\n② Follow the guided camera system to capture all 4 angles\n③ Our AI analyzes the physical pattern in your grounds\n④ Receive a detailed analysis based on what's actually in your cup\n\nWHAT MAKES IT DIFFERENT\n• Real photo analysis — the AI reads your specific cup, not a generic profile\n• 4-angle guided capture for complete pattern coverage\n• Computer vision model trained specifically on coffee ground formations\n• Full AI responses in English & Turkish\n\nRooted in the tradition of tasseography, FalorAI brings this cultural art into the modern era through artificial intelligence.",
    links: {
      googlePlay:
        "https://play.google.com/store/apps/details?id=com.deepcvision.falorai",
    },
  },
  {
    id: "hepbme",
    stack: ["Flutter", "Supabase", "AWS", "VectorShift"],
    name: "HepB & Me",
    client: "Professor Patrick Kennedy",
    services: ["Branding", "App design", "iOS & Android app", "Backend", "AI assistant"],
    designCredit: "App design with Understated",
    designImage: designHepbme,
    tagline:
      "Track, understand & manage Hepatitis B with personalised health insights.",
    platforms: ["iOS", "Android"],
    category: "Health",
    img: hepbme1,
    gallery: [
      {
        img: hepbme2,
        title: "Your liver health at a glance",
        caption:
          "HBV DNA, ALT and fibrosis results, colour-coded so changes are obvious.",
      },
      {
        img: hepbme4,
        title: "Know what needs attention",
        caption:
          "Clear flags on the results your clinician will want to talk through.",
      },
      {
        img: hepbme3,
        title: "Personalised risk assessment",
        caption:
          "Tailored insight across BMI, comorbidity and lifestyle factors.",
      },
      {
        img: hepbme1,
        title: "An AI assistant that knows the subject",
        caption:
          "Ask about treatment, vaccination or co-infection and get a reliable answer instantly.",
      },
    ],
    description:
      "HepB&Me is your smart health companion for managing Hepatitis B (HBV) — built with leading hepatologists and clinical researchers to put personalised, evidence-based Hepatitis B management in your pocket.\n\nWhether you're newly diagnosed or living with chronic Hepatitis B, HepB&Me helps you understand your condition, track your liver health results, and stay on top of your care alongside your healthcare team.\n\nKEY FEATURES\n• Smart Dashboard — your Hepatitis B status and key trends at a glance.\n• Health Trends Tracking — log and visualise your results (HBV DNA, ALT, fibrosis and more) and spot changes early.\n• Personalised Insights — tailored risk assessments for your liver health, including liver cancer (HCC) surveillance guidance.\n• AI Health Assistant — ask questions and get instant, reliable answers through the in-app chatbot.\n• Smart Reminders — never miss medications, appointments, blood tests or scans.\n• Multilingual — available in English, Vietnamese, Chinese and Bengali.\n\nFOR HEALTHCARE PROFESSIONALS\nA dedicated clinician view to support patient care.",
    links: {
      appStore: "https://apps.apple.com/us/app/hepb-me/id6736882788",
      googlePlay:
        "https://play.google.com/store/apps/details?id=com.deepcvision.hepbme",
      demo: "/hepbandme",
    },
  },
  {
    id: "mahbub",
    stack: ["Flutter", "Supabase", "AWS"],
    name: "Mahbub Heart Health",
    client: "Dr Zubaida Rahman",
    services: ["Branding", "iOS & Android app", "Backend"],
    tagline:
      "Manage heart health with ease — gain insights and personalised support.",
    platforms: ["iOS", "Android"],
    category: "Health",
    img: mahbub1,
    gallery: [
      {
        img: mahbub1,
        title: "Know your heart age",
        caption:
          "Estimated from established cardiovascular risk models — an indicator, not a diagnosis.",
      },
      {
        img: mahbub2,
        title: "Built from your real data",
        caption:
          "Personal, lifestyle and clinical details keep the estimate honest.",
      },
      {
        img: mahbub3,
        title: "Track it over time",
        caption:
          "Log entries and watch your heart age respond to the changes you make.",
      },
    ],
    description:
      "Manage heart health with ease — gain insights and access personalised support.\n\nMahbub estimates your Heart Age from established cardiovascular risk models, using the personal, lifestyle and clinical information you record. Keep your profile up to date and watch your Heart Age respond as you log entries over time.\n\nRegular exercise, healthy sleep, balanced nutrition, not smoking, and good glucose control can all help reduce your Heart Age.\n\nEstimates are based on risk factors and are not a diagnosis. Always consult your doctor before making medical decisions.",
    links: {
      appStore: "https://apps.apple.com/us/app/mahbub/id6760599213",
      googlePlay:
        "https://play.google.com/store/apps/details?id=com.deepcvision.mahbub",
    },
  },
  {
    id: "refleks",
    stack: ["Flutter", "Supabase", "AWS"],
    name: "ReFleks",
    client: "Queen Mary Innovation",
    services: ["Branding", "App design", "iOS & Android app", "Backend"],
    designCredit: "App design with Understated",
    designImage: designRefleks,
    award: "Winner — Zinc Impact Award",
    tagline:
      "Monitors knee health and wellbeing through questionnaires and wearables.",
    platforms: ["iOS", "Android"],
    category: "Health",
    img: refleks1,
    gallery: [
      {
        img: refleks1,
        title: "Guided questionnaires",
        caption:
          "Short, illustrated steps covering quality of life and day-to-day mood.",
      },
      {
        img: refleks2,
        title: "Rated on real movements",
        caption:
          "Everyday actions like bending to the floor, scored on a plain difficulty scale.",
      },
      {
        img: refleks3,
        title: "See the trend, not just today",
        caption:
          "WOMAC scores, sleep, mood and independence charted between appointments.",
      },
    ],
    description:
      "ReFleks App monitors knee health, as well as overall physical and mental wellbeing, through questionnaires and data from your wearables.\n\nGuided questionnaires cover quality of life, physical function, pain and stiffness — building a picture of how your knee is affecting daily activities such as bending, walking and sleeping.\n\nResults are charted over time alongside WOMAC scores, sleep, mood, social activity and independence, so you and your clinician can see how things are trending between appointments.",
    links: {
      appStore: "https://apps.apple.com/us/app/refleks/id6477490851",
      googlePlay:
        "https://play.google.com/store/apps/details?id=com.deepcvision.Refleks",
    },
  },
  {
    id: "morphosonic",
    services: ["Product design", "Android app", "On-device audio & AI"],
    name: "Morphosonic",
    tagline:
      "Turn any photo into generative music and mesmerizing, beat-synced visuals.",
    platforms: ["Android"],
    category: "AI",
    img: morphosonic1,
    gallery: [
      {
        img: morphosonic1,
        title: "Your photo, playing",
        caption:
          "Drums, bass and melody layer up as the app traces the shapes in your image.",
      },
      {
        img: morphosonic2,
        title: "Five genres, one tap",
        caption:
          "Pop, Rock, Latin, Reggae or Diwali — then capture it as a GIF and share.",
      },
    ],
    description:
      "Every photo has a sound. Morphosonic finds it.\n\nPoint Morphosonic at anything — a face, a city street, a sketch, the sky — and watch it trace the lines and shapes in your image, then play them back as living, generative music that evolves before your eyes.\n\nNo two photos sound the same. The brightness, colour, texture and detail of your image shape the melody, the rhythm and the mood — so every picture becomes its own one-of-a-kind track.\n\nFIVE GENRES, ONE TAP\nSwitch between Pop, Rock, Latin, Reggae and Diwali — each with its own scale, groove and feel.\n\nHYPNOTIC LIVE VISUALS\nGlowing edge-detection patterns pulse and shimmer in perfect time with every beat.\n\nPRIVATE BY DESIGN\nYour photos never leave your device. Everything is processed locally — no accounts, no sign-up.",
    links: {
      googlePlay:
        "https://play.google.com/store/apps/details?id=com.deepcvision.morphosonic",
    },
  },

  // ---- Client work -------------------------------------------------------
  {
    id: "pixels-to-populations",
    type: "web",
    name: "From Pixels to Populations",
    client: "Queen Mary University of London",
    services: ["Interactive front end", "AI photo-ID flow", "Localisation (5 languages)"],
    tagline:
      "An interactive science-outreach game teaching population estimation with AI photo-ID.",
    platforms: ["Web"],
    category: "AI",
    img: ptp1,
    gallery: [
      {
        img: ptp1,
        title: "The Sea Turtle Population Survey Challenge",
        caption:
          "Players take on the role of a field scientist and run two survey dives.",
      },
      {
        img: ptp3,
        title: "Choose your diver",
        caption:
          "Sprint or longer survey — the choice changes how large a photo dataset you gather.",
      },
      {
        img: ptp2,
        title: "Three habitats, three difficulties",
        caption:
          "Coral canyon, seagrass meadow or deep ridge — each changes turtle behaviour and photo quality.",
      },
      {
        img: ptp4,
        title: "Photo-ID, with or without AI",
        caption:
          "Match turtles across both dives by their facial scale patterns, using AI Assist or unaided.",
      },
    ],
    description:
      "An interactive science-outreach web app built for Queen Mary University of London, funded by EPSRC.\n\nPlayers survey sea turtles across two dives, photograph the animals they encounter, then match individuals between dives using photo-identification — with or without AI assistance — to estimate the total population of the habitat.\n\nWHAT IT TEACHES\nThe game makes capture-recapture population estimation tangible. Three scenarios vary turtle behaviour and photo quality, so players see first-hand how field conditions and imperfect AI change the confidence of a population estimate.\n\nWHAT WE BUILT\nThe full interactive front end, the survey and photo-matching mechanics, the AI-assisted identification flow, and localisation into five languages (English, Arabic, Greek, Spanish and French).",
    links: {
      website: "https://frompixelstopopulations.com/",
    },
  },
  {
    id: "tabletop-rnd",
    stack: ["AWS", "AWS Amplify"],
    type: "backend",
    name: "Tabletop R&D — Gameplay Engine",
    client: "Tabletop R&D",
    services: [
      "Backend engineering",
      "Simulation module",
      "AWS",
      "AWS Amplify",
    ],
    tagline:
      "AWS backend and gameplay simulation module for automated board-game playtesting.",
    platforms: ["Backend", "AWS"],
    category: "Games",
    img: null,
    gallery: [],
    description:
      "Backend engineering for Tabletop R&D, a Queen Mary University of London spin-out that provides automated testing services to board game designers.\n\nTheir platform builds a \"digital twin\" of a tabletop game and simulates thousands of plays in minutes, producing statistical insight into game balance, scoring and strategy effectiveness — catching issues that are slow and expensive to surface through human playtesting alone.\n\nWHAT WE BUILT\nWe delivered the backend gameplay simulation module that sits behind that service, built and deployed on AWS using AWS Amplify.\n\nThe work is server-side and runs inside the client's own platform, so there is no public interface to show.",
    links: {
      website: "https://www.tabletoprnd.co.uk/",
    },
  },
];
